import React from "react";
import { NetworkAPI } from "apis";
import ModalWrapper from "components/common/ModalWrapper";
import LoadingUI from "components/common/LoadingUI";
import PromptModal from "components/common/PromptModal";

const buttonActionClass =
  "px-2 py-1 bg-gray-200 text-xs rounded border border-gray-400 shadow hover:bg-gray-300 text-gray-900 font-semibold";

class NetworkEnsureResourcesButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      isLoading: false,
      resultMsg: null,

      isPromptModalOpen: false,
      promptHeader: null,
      promptMessage: null,
      promptAction: null,
      promptMsg: [],
    };

    this.handleEnsureResources = this.handleEnsureResources.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  async handleEnsureResources(isPrompt = true) {
    const { networkId, name } = this.props;
    if (!networkId) return;

    if (isPrompt) {
      this.setState({
        isPromptModalOpen: true,
        promptMsg: [],
        promptHeader: "Ensure Resources",
        promptMessage: (
          <>
            Are you sure you want to ensure resources for network? <br />
            <span className="font-semibold text-blue-600">
              {networkId} {name}
            </span>
          </>
        ),
        promptAction: () => this.handleEnsureResources(false),
      });
      return;
    }

    this.setState({
      isPromptModalOpen: false,
    });

    this.setState({ isLoading: true, isModalOpen: true });
    try {
      const { networkId } = this.props;

      const r = await NetworkAPI.triggerEnsureResources({ networkId });

      this.setState({
        resultMsg: JSON.stringify(r, null, 2),
        isLoading: false,
      });
    } catch (err) {
      console.log(err);
      this.setState({
        resultMsg: err,
        isLoading: false,
      });
    }
  }

  handleModalClose() {
    this.setState({
      isModalOpen: false,
      isLoading: false,
      resultMsg: null,
    });
  }

  render() {
    const {
      isLoading,
      isModalOpen,
      resultMsg,
      isPromptModalOpen,
      promptAction,
      promptHeader,
      promptMessage,
      promptMsg,
    } = this.state;

    const { customActionClass } = this.props;
    return (
      <>
        <button
          type="button"
          className={customActionClass || buttonActionClass}
          onClick={this.handleEnsureResources}
        >
          Ensure Resources
        </button>
        {isModalOpen && (
          <SyncResultModal
            isLoading={isLoading}
            syncResult={resultMsg}
            isOpenViewModal={isModalOpen}
            handleClose={this.handleModalClose}
          ></SyncResultModal>
        )}
        {isPromptModalOpen && (
          <PromptModal
            isLoading={isLoading}
            isOpenModal={isPromptModalOpen}
            handleConfirm={promptAction}
            msg={promptMsg}
            handleCancel={() =>
              this.setState({ isPromptModalOpen: false, promptMsg: [] })
            }
            header={promptHeader}
          >
            {promptMessage}
          </PromptModal>
        )}
      </>
    );
  }
}

class SyncResultModal extends React.PureComponent {
  render() {
    const { isLoading, syncResult, isOpenViewModal, handleClose } = this.props;

    return (
      <ModalWrapper
        isOpen={isOpenViewModal}
        showCloseFooter={true}
        handleClose={handleClose}
        customOverlayStyle={{ zIndex: 100 }}
        title="Ensure Resources:"
      >
        <div className="overflow-y-auto" style={{ maxHeight: "300px" }}>
          {isLoading ? (
            <LoadingUI iconOnly={true}></LoadingUI>
          ) : (
            <textarea
              className="w-full bg-gray-200 p-1"
              rows={10}
              defaultValue={syncResult}
              readOnly
            ></textarea>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

export default NetworkEnsureResourcesButton;
